import React from 'react';
import GhlNavbar from './GhlNavbar';
import GhlHero from './GhlHero';
import GhlPainPoints from './GhlPainPoints';
import GhlStats from './GhlStats';
import GhlFeatures from './GhlFeatures';
import GhlUseCases from './GhlUseCases';
import GhlComparison from './GhlComparison';
import GhlPricing from './GhlPricing';
import GhlFaq from './GhlFaq';
import GhlFooter from './GhlFooter';

const GhlPage: React.FC = () => {
  return (
    <div className="bg-slate-950 min-h-screen text-slate-300 font-sans antialiased selection:bg-emerald-500/30 selection:text-emerald-200">
      <GhlNavbar />
      <main>
        <GhlHero />
        <GhlPainPoints />
        <GhlStats />
        <GhlFeatures />
        <GhlUseCases />
        <GhlComparison />
        <GhlPricing />
        <GhlFaq />
      </main>
      <GhlFooter />
    </div>
  );
};

export default GhlPage;
